<template>
  <div class="talent-total-panel">
    <div class="panel-title">人才总量（截止2025年）</div>
    <div class="title-count">
      <img src="../assets/images/rencai_2.png" style="width: 32px;height: 32px;margin-left: 30px;"></img>
      <div class="title-count-value">
        <span class="title-count-value" style="margin-left: 5px;">19.19</span>
        <span style="font-size: 12px;" class="title-count-value">万人</span>

      </div>
    </div>
    <div class="panel-content">
      <div class="panel-title">近六年新来象大学生</div>
      <div ref="industryChart" class="industry-chart"></div>
    </div>
  </div>
</template>

<script>
import rencai1 from '../assets/images/rencai_1.png'
import rencai2 from '../assets/images/rencai_2.png'
import rencai3 from '../assets/images/rencai_3.png'
import rencai4 from '../assets/images/rencai_4.png'
import rencai5 from '../assets/images/rencai_5.png'
import rencai6 from '../assets/images/rencai_6.png'
import * as echarts from 'echarts';
export default {
  name: 'TalentTotalPanel',
  props: {
    dataList: {
      type: Array,
      required: true
    }
  },
  computed: {
    sortedDataList() {
      if (!this.dataList || this.dataList.length === 0) return []

      // 按年份排序 - 提取年份数字进行排序
      return [...this.dataList].sort((a, b) => {
        const yearA = this.extractYear(a.name)
        const yearB = this.extractYear(b.name)
        return yearA - yearB // 升序排列（从早到晚）
        // 如果需要降序排列（从晚到早），改为：return yearB - yearA
      })
    }
  },
  watch: {
    dataList: {
      handler(newVal) {
        if (newVal.length > 0) {
          // 使用排序后的数据
          const sortedData = this.sortedDataList
          sortedData.forEach((item, index) => {
            if (index === 0) {
              item.color = '#18CDFF'
            }
            if (index === 1) {
              item.color = '#FBA717'
            }
            if (index === 2) {
              item.color = '#03A25D'
            }
            if (index === 3) {
              item.color = '#b39ddb'
            }
            if (index === 4) {
              item.color = '#2075DC'
            }
            if (index === 5) {
              item.color = '#FF752B'
            }

          })
          this.initIndustryChart()
        }
        console.log("排序后的数据", JSON.stringify(this.sortedDataList))
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      industryList: [
        { name: '2020年', value: 45, color: '#ffe066' },
        { name: '2021年', value: 40, color: '#ffb347' },
        { name: '2022年', value: 11, color: '#ff5ca2' },
        { name: '2023年', value: 115, color: '#b39ddb' },
        { name: '2024年', value: 35, color: '#4d8aff' },
      ]
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    // 提取年份数字的方法
    extractYear(name) {
      if (!name) return 0
      // 匹配4位数字（年份）
      const match = name.match(/(\d{4})/)
      return match ? parseInt(match[1]) : 0
    },
    initIndustryChart() {
      if (!this.$refs.industryChart) return
      if (this.chart) {
        this.chart.dispose();
      }
      const chart = echarts.init(this.$refs.industryChart, null, { renderer: 'svg' });
      this.chart = chart;
      chart.setOption({
        grid: { left: 80, right: 40, top: 30, bottom: 30 },
        xAxis: {
          type: 'category',
          data: this.sortedDataList.map(i => i.name),
          axisLabel: { color: '#000', fontSize: 13 },
          axisLine: { lineStyle: { color: '#A7DDFDFF' } },
          axisTick: { show: true }
        },
        yAxis: [
          { type: 'value', name: '',  axisLabel: { color: '#000', fontSize: 13 }}, // 左侧 Y 轴
        ],
        series: [
          {
            type: 'bar',
            data: this.sortedDataList.map(i => ({ value: i.value, itemStyle: { color: i.color } })),
            barWidth: 40,
            label: {
              show: true,
              position: 'top',
              color: '#000',
              fontSize: 12,
              formatter: "{c}人"
            }
          }
        ]
      });
    },
    getTalentBg(index) {
      if (index === 0) {
        return `url(${rencai1})`
      }
      if (index === 1) {
        return `url(${rencai2})`
      }
      if (index === 2) {
        return `url(${rencai3})`
      }
      if (index === 3) {
        return `url(${rencai4})`
      }
      if (index === 4) {
        return `url(${rencai5})`
      }
      if (index === 5) {
        return `url(${rencai6})`
      }
      return `url(${rencai1})`
    },
    handleResize() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = setTimeout(() => {
        if (this.chart) {
          this.chart.resize();
        }
      }, 100);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
    if (this.chart) {
      this.chart.dispose();
    }
  }

}
</script>

<style scoped>
.industry-chart {
  height: 180px;
  width: 99%;
}

.talent-total-panel {
  width: 100%;


}

.panel-content {
  background-image: url('../assets/images/icon-rencai_bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.panel-title {
  display: flex;
  align-items: center;
  height: 40px;
  font-size: 18px;
  color: #fff;
  font-weight: bold;
  padding-left: 20px;
  background-image: url('../assets/images/icon-rencai.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.panel-list {
  display: flex;
  flex-wrap: wrap;
  padding-left: 10px;
  padding-right: 5px;
  padding-bottom: 20px;
  gap: 16px 12px;
}

.panel-item {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  box-sizing: border-box;
  width: 48%;
  height: 80px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 0px 0px 0px 0px;
}

.icon {
  width: 53px;
  height: 53px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.info {
  flex: 1;
}

.type {
  font-size: 14px;
  color: #28282899;
  opacity: 0.85;
}

.count {
  font-size: 22px;
  color: #282828;
  font-weight: bold;
  line-height: 1;
}

.count span {
  font-size: 14px;
  margin-left: 2px;
  color: #282828;
}

.title-count {
  font-size: 14px;
  margin-bottom: 20px;
  height: 50px;
  background: rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
}

.title-count-text {
  font-family: Alibaba PuHuiTi 2.0;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  font-variation-settings: "opsz" auto;
  color: #282828;
}

.title-count-value {
  font-family: Alibaba PuHuiTi 2.0;
  font-weight: 1000;
  font-size: 24px;
  font-variation-settings: "opsz" auto;
  color: #0E6CFB;
}
</style>
